/** Max DELETEs in flight during a bulk delete. Backend cascades are heavy and the DB pool is 30. */
export const BULK_DELETE_CONCURRENCY = 4;

/**
 * Runs `fn` over `items` with at most `limit` calls in flight and returns settled results in
 * input order, so callers can map a result back to the item that produced it.
 */
export const runWithConcurrency = async <TItem, TResult>(
  items: TItem[],
  limit: number,
  fn: (item: TItem, index: number) => Promise<TResult>
): Promise<PromiseSettledResult<TResult>[]> => {
  const results: PromiseSettledResult<TResult>[] = new Array(items.length);
  let cursor = 0;

  const worker = async () => {
    while (cursor < items.length) {
      const index = cursor;
      cursor += 1;
      try {
        results[index] = { status: 'fulfilled', value: await fn(items[index], index) };
      } catch (reason) {
        results[index] = { status: 'rejected', reason };
      }
    }
  };

  await Promise.all(Array.from({ length: Math.max(1, Math.min(limit, items.length)) }, worker));

  return results;
};
